import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-modal',
    styleUrls: ['./modal.component.scss'],
    templateUrl: './modal.component.html',
    standalone: false
})
export class ModalComponent implements OnInit {

  private static ID = 0;

  @Input()
  public header: string;
  public readonly id: number;

  constructor() {
    this.id = ModalComponent.ID++;
  }

  public ngOnInit() {
  }

  public open(): void {
    this.show(true);
  }

  public close(): void {
    this.show(false);
  }

  private show(show: boolean): void {
    // Display modal window.
    document.getElementById(`modal-${this.id}`).style.display = show ? 'block' : 'none';
    // Hide main scroll bar when modal window is open.
    document.getElementsByTagName('body').item(0).style.overflowY = show ? 'hidden' : 'scroll';
  }
}
